import { memo } from 'react';
import { NavListRoot } from './NavList';

/* ============================================================================
   Menu horizontal - visual novo.

   Substitui Stack do MUI + o `hideScrollbar` que escondia a barra de rolagem com
   `overflowY: 'scroll'` (eixo ERRADO para um menu que rola na horizontal).

   Aqui a rolagem e horizontal de verdade, e a barra continua escondida - mas com o
   cuidado que faltava: quem tem muitos itens ainda consegue arrastar, e os grupos
   sao separados por um traco em vez de ficarem encostados.
   ============================================================================ */

function NavSectionHorizontal({ navConfig = [] }) {
  return (
    <div className="rounded-lg bg-soft px-1.5">
      <div className="flex justify-center">
        <div className="flex items-center gap-1 overflow-x-auto py-1.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {navConfig.map((group, i) => (
            <div key={group.subheader} className="flex flex-none items-center gap-1">
              {i > 0 && <span className="mx-1 h-5 w-px flex-none bg-line" aria-hidden />}
              {group.items?.map((list) => (
                <NavListRoot key={list.title} list={list} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(NavSectionHorizontal);
